import { useState } from "react";
import { Box, Typography, Link, Tooltip, ClickAwayListener } from "@mui/material";
import { NewTask } from "./types";

const RequirementInfo = ({
  requirementText,
  requirementNumber,
  requirementCode
}: {
  requirementText: string;
  requirementNumber: string;
  requirementCode: string;
}) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <Box minWidth={180}>
      <Typography variant="body2" display="inline-block" sx={{ fontSize: "0.75rem", opacity: 0.3, cursor: "default" }}>
        created by{" "}
      </Typography>{" "}
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          title={
            <Typography variant="body2" padding={0.5}>
              {requirementText}
            </Typography>
          }
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
        >
          <Link
            display="inline-block"
            onClick={handleTooltipOpen}
            sx={{ fontSize: "0.75rem", opacity: 0.3, fontWeight: 600, cursor: "pointer" }}
          >
            Req: #{requirementNumber} {requirementCode}
          </Link>
        </Tooltip>
      </ClickAwayListener>
    </Box>
  );
};

export default RequirementInfo;
